import styled from 'styled-components'
import Typograpy from 'core/components/Typography'

const StyledList = styled(Typograpy)`
  & > ul {
    margin-top: 0px;
    padding-inline: 18px;
  }
`
export { StyledList }
